import React from 'react';
import './components.css';

export default function AskContent() {
  return (
    <div className='askContent'>
      <h3 className='oswald mt-2'>ask me anything</h3>
      <p className='m-0'>
        Hey there, I am glad that you're here and want to have a word with me.
      </p>
      <p className='m-0'>
        You can reach out to me on my instagram account (@akulsr0), as I am
        mostly active there, or mail me at:
      </p>
      <p className='m-0' style={{ fontWeight: 400 }}>
        akulsr0@gmail.com
      </p>
    </div>
  );
}
